<template>
    <div class="bg-muted drop-shadow-md h-20 px-4">
        <div class="flex items-center justify-between h-full space-x-6">
            <div>
                <Link class="mr-auto" :href="route('homepage')">
                    <app-logo class="max-w-[150px] 2xl:max-w-xs max-h-10" theme="dark"></app-logo>
                </Link>
            </div>

            <div class="flex items-center space-x-6 hidden xl:flex relative">
                <div class="absolute hidden 2xl:block -bottom-7 -left-10">
                    <img class="w-20" src="/images/steves-reviews.png" alt="Steves Reviews"/>
                </div>
                <Link class="font-bold xl:text-sm 2xl:text-base" :href="route('steves-reviews.index')">Steve's Reviews</Link>
                <Link class="font-bold xl:text-sm 2xl:text-base" :href="route('brands.index')">Reviews by Brand</Link>
                <Link class="font-bold xl:text-sm 2xl:text-base" :href="route('manufacturers.index')">Reviews by Car</Link>
                <Link class="font-bold xl:text-sm 2xl:text-base" :href="route('awards')">Tyre Seeker Awards</Link>
                <Link class="font-bold xl:text-sm 2xl:text-base" :href="route('advice.index')" v-if="route().has('advice.index')">Tyre Help &amp;
                    Advice
                </Link>
                <Link class="font-bold xl:text-sm 2xl:text-base" :href="route('news.index')" v-if="route().has('news.index')">Tyre News</Link>
            </div>

            <div class="flex items-center space-x-6 hidden xl:flex">
                <font-awesome-icon v-if="route().has('search')"
                                   @click="showSearch = !showSearch"
                                   class="cursor-pointer"
                                   :icon="['far', 'search']"
                                   size="lg"></font-awesome-icon>

                <AppButton class="hidden 2xl:block xl:text-sm 2xl:text-base" size="normal" :href="route('reviews.create')">
                    Submit a review
                </AppButton>

                <AppButton class="block 2xl:hidden" size="small" :href="route('reviews.create')">
                    Submit a review
                </AppButton>
            </div>

            <div class="flex items-center space-x-6 flex xl:hidden">
                <font-awesome-icon v-if="route().has('search')"
                                   @click="showSearch = !showSearch"
                                   class="cursor-pointer"
                                   :icon="['far', 'search']"
                                   size="lg"></font-awesome-icon>

                <font-awesome-icon @click="$emit('toggle-mobile-nav')"
                                   class="cursor-pointer w-4"
                                   :icon="['far', 'bars']"
                                   size="lg"></font-awesome-icon>
            </div>
        </div>
    </div>

    <search-modal @close="showSearch = false" :show="showSearch"></search-modal>
</template>
<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import AppLogo from "@/Components/AppLogo.vue";
import InputBasic from "@/Components/Forms/Inputs/InputBasic.vue";
import AppContainer from "@/Layouts/AppContainer";
import {Link} from "@inertiajs/inertia-vue3";
import AppButton from "@/Components/AppButton";
import SearchModal from "@/Components/Modals/SearchModal";

export default {
    components: {SearchModal, AppButton, AppContainer, FontAwesomeIcon, AppLogo, InputBasic, Link},
    emits: ["toggle-mobile-nav"],
    props: {
        mobileNavShown: Boolean
    },
    data() {
        return {
            showSearch: false,
            search: null
        };
    },
    mounted() {
        window.addEventListener("keyup", event => {
            if (event.key === "/") {
                this.showSearch = true;
            }
        });
    },
    methods: {
        doSearch() {
            console.log("searching");
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
